module.exports = __webpack_public_path__ + "b5bd864e9c36875b21d96424f0dfe8b1.jpg";